import Request from './Request';

class Api {
    _token = null;

    async sendDefaultRequest(method, url, data, params) {
        const request = new Request(method, url, data);
        request.token = this.token;
        request.setHeader('Content-Type', 'application/json');
        try {
            let response;
            if (params === true) {
                response = await request.executeCancelable();
            } else {
                response = await request.execute();
            }
            return response;
        } catch (err) {
            // if (err.status === 401 && response.url.indexOf(`/${API.logout}`) < 0) {
            //     logout(ERRORS.user.sessionExpired);
            // }
            throw err;
        }
    }

    route(slug, params = {}) {
        return window.Routing.generate(slug, params);
    }

    async get(url, data, params = {}) {
        return await this.sendDefaultRequest('get', url, data, params);
    }

    async post(url, data, params) {
        return this.sendDefaultRequest('post', url, data, params);
    }

    async put(url, data, params) {
        return this.sendDefaultRequest('put', url, data, params);
    }

    async patch(url, data, params) {
        return this.sendDefaultRequest('patch', url, data, params);
    }

    async delete(url, data, params) {
        return this.sendDefaultRequest('delete', url, data, params);
    }

    async upload(url, file, params = {}) {
        const data = new FormData();
        if (file instanceof File) {
            data.append(params.uploadParamName || 'file', file);
        } else {
            Object.keys(file).forEach(prop => {
                if (file[prop] instanceof File) {
                    data.append(`${prop}[${params.uploadParamName || 'file'}]`, file[prop]);
                } else {
                    data.append(prop, file[prop]);
                }
            });
        }

        const request = new Request(params.method || 'post', url);
        request.params.body = data;
        request.token = this.token;

        try {
            return await request.execute();
        } catch (err) {
            throw err;
        }
    }

    set token(token) {
        this._token = token;
    }

    get token() {
        return this._token;
    }

    getOneTimeAuthToken() {
        return this.get(this.route('partnermarketing_user_get_one_time_auth_token'));
    }

    async oneTimeAuthRedirect(slug, slugParams = {}) {
        const token = await this.getOneTimeAuthToken();
        const url = `${this.route(slug, slugParams)}?${token.urlQueryString}`;

        const response = await fetch(url);

        if (!response.ok) {
            let errorMessage = `HTTP ${response.status}`;

            try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorData.error || errorMessage;
            } catch {
                errorMessage = await response.text() || errorMessage;
            }

            throw new Error(errorMessage);
        }

        const contentType = response.headers.get('content-type') || '';

        if (contentType.includes('application/json')) {
            const data = await response.json();
            throw new Error(data.message || 'Unexpected JSON response');
        }

        const blob = await response.blob();
        this.downloadBlob(blob, response);
    }

    downloadBlob(blob, response) {
        const downloadUrl = window.URL.createObjectURL(blob);

        const fileName = this.getFileNameFromHeaders(response) || 'data-report';

        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = fileName;
        a.style.display = 'none';

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 100);
    }

    getFileNameFromHeaders(response) {
        const contentDisposition = response.headers.get('content-disposition');
        if (contentDisposition) {
            const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            return match ? match[1].replace(/['"]/g, '') : null;
        }
        return null;
    }
}

export default new Api();
